require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-how-can-the-idb-improve-the-biobusiness-project-in.json") })
        }
      }, "path---en-us-project-how-can-the-idb-improve-the-biobusiness-project-in");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-how-can-the-idb-improve-the-biobusiness-project-in!./.cache/json/en-us-project-how-can-the-idb-improve-the-biobusiness-project-in.json
// module id = 518
// module chunks = 231608221292675